import React, { useEffect, useState } from "react";
import SelectAutocomplete from "common/SelectAutocomplete.jsx";
import Request from "common/Request";
import { parsePolicyNames } from "../api.js";
import { useBqnId } from "common/BqnContext.jsx";

const loadPolicyNames = (bqnId) =>
  ifCl.run("show api policy").then(response => parsePolicyNames(response, bqnId)).then(names => Array.from(new Set(names)));

const nameAsLabelAndValue = (names) =>
  names.map((name) => ({ label: name, value: name }));

const asOptions = (policies) => ({
  options: [{ value: "all", label: "All policies" }, ...policies],
});

const PolicyInput = ({ name, selected, onChange }) => {
  const [request, setRequest] = useState();
  const bqnId = useBqnId();

  useEffect(() => {
    doLoad();
  }, [bqnId])

  function doLoad(){
    setRequest(loadPolicyNames(bqnId).then(nameAsLabelAndValue).then(asOptions))
  }

  return <Request during={request}>
    {({ options = [] }) => (
      <SelectAutocomplete
        title="Policies"
        icon="folder_open"
        options={options}
        name={name}
        selected={selected}
        onChange= {(value)=> onChange(value, "policy")}
      />
    )}
  </Request>
};

export default PolicyInput;
